module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag39_1845AT.f72b239d.jpg";